<template>
  <div id="training-files">
    <b-container fluid>
      <b-row class="mb-6 mt-6">
        <b-col><h4>Pliki</h4></b-col>
        <b-col>
          <vs-button type="filled round" icon-pack="feather" icon="icon-save" class="float-right ml-4" @click="addFile">
            Zapisz
          </vs-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <vs-input
            v-model="payload.name"
            placeholder="Nazwa pliku"
            class="w-100 mb-3"
            type="text"
          />
          <field-error :errorsBag="formErrors" fieldName="file"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-file
            v-model="payload.file"
            placeholder="Dodaj plik"
            drop-placeholder="Upuść tutaj"
            browse-text="Wybierz"
            class="w-100"
          />
          <field-error :errorsBag="formErrors" fieldName="file"/>
        </b-col>
      </b-row>
      <b-row v-if="files" class="mt-4">
        <b-col cols="4" v-for="f in files" class="mt-4">
        <files-card :name="f.name" enable-edit  @delete="deleteFile(f.uuid)"/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import FieldError from "@/components/wod/forms/FieldError"
import axios from "@/axios"
import notification from "@/notification";
import FilesCard from "@/components/wod/cards/FilesCard";

export default {
  name: 'TrainingFiles',
  components:{
    FilesCard,
    FieldError
  },
  data () {
    return {
      formErrors: {},
      files: null,
      payload: {
        file: null,
        name: null
      },
    }
  },
  mounted() {
    this.getTraining()
  },
  methods: {
    addFile() {
      const formData = new FormData()
      formData.append('name', this.payload.name)
      formData.append('file', this.payload.file)
      axios.post(`/cp/trainings/${this.$route.params.uuid}/add-file`, formData)
        .then(() => {
          this.$vs.notify(notification.success('Plik został dodany'))
          this.getTraining()
        })
        .catch(error => {
            if(error.response && error.response.status === 422){
                this.formErrors =  error.response.data.errors
            }
            else {
              this.$vs.notify(notification.error(error.message))
            }
        })
    },

    deleteFile(uuid) {
      axios.delete(`/cp/training-files/${uuid}`)
        .then(() => {
          this.$vs.notify(notification.success('Plik został usunięty'))
          this.getTraining()
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
    },

    getTraining() {
      axios.get(`/cp/trainings/${this.$route.params.uuid}`)
        .then(response => {
          if(response.data.data && response.data.data.training_files) this.files = response.data.data.training_files
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
    },

  },

}
</script>
